import { useState } from 'react';
import { Redirect } from 'react-router';
import Modal from '../../Modal';

const FooterUniqueModal = () => {
	const [redirect, setRedirect] = useState<boolean>(false);

	return (
		<>
			{redirect && <Redirect to="/contributions/dashboard" />}

			<Modal title="Oops!">
				<p>You have already created one footer across your website. To create a new one, go to Dashboard and delete the previous footer.</p>

				<button className="rgModalButton primary" onClick={() => setRedirect(true)}>Go to Dashboard</button>
			</Modal>
		</>
	)
}

export default FooterUniqueModal;
